<div class="card rounded-4 border-0 shadow-sm mb-3">
  <div class="card-body">
    <h6 class="card-title fw-bold mb-3">Estadísticas</h6>
    <ul class="list-group list-group-flush">
      <li
        class="list-group-item border-0 d-flex justify-content-between align-items-center py-2"
      >
        <div class="d-flex align-items-center">
          <div class="icon-bg me-2">
            <i class="fa-solid fa-users text-primary"></i>
          </div>
          <span>Candidatos que aplicaron</span>
        </div>
        <span class="badge bg-primary rounded-pill">{{
          candidatesCount
        }}</span>
      </li>
      <li
        class="list-group-item border-0 d-flex justify-content-between align-items-center py-2"
      >
        <div class="d-flex align-items-center">
          <div class="icon-bg me-2">
            <i class="fa-solid fa-handshake text-primary"></i>
          </div>
          <span>A entrevista</span>
        </div>
        <span class="badge bg-primary rounded-pill">{{
          interviewCount
        }}</span>
      </li>
      <li
        class="list-group-item border-0 d-flex justify-content-between align-items-center py-3 bg-light rounded-3"
      >
        <div class="d-flex align-items-center">
          <div class="icon-bg me-2">
            <i class="fa-regular fa-eye text-primary fs-5"></i>
          </div>
          <span class="text-primary">Vistas</span>
        </div>
        <span
          class="badge bg-primary rounded-pill"
        >
          {{ getViewCount() }}
        </span>
      </li>
    </ul>
  </div>
</div>
